// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".add-creative-to-concept-modal-body {\n\tposition: relative;\n}\n\n.add-existing-creatives-to-concept .c-modal__content{\n\tmargin: 0;\n}\n", "",{"version":3,"sources":["AddCreativesToConcept.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;AACV","file":"AddCreativesToConcept.css","sourcesContent":[".add-creative-to-concept-modal-body {\n\tposition: relative;\n}\n\n.add-existing-creatives-to-concept .c-modal__content{\n\tmargin: 0;\n}\n"]}]);
// Exports
module.exports = exports;
